<template>
  <header class="nav background" :class="{ 'nav background_dev': env == 'development' || env == 'qa' }" style="border-bottom: 1px;">
    <div class="nav-left">
      <span style="height: 110px;">
        <div style="width: 100px; height: 110px;"></div>
      </span>
      <span class="nav-item" style="padding-left:0px;">
        <a @click="goToMenu" style="font-size: 24px; color: #FFF;">Philips Care Portal</a>
      </span>
    </div>
    <div class="nav-right" style="color: #FFF;">
      <span class="nav-item" style="font-size: 13px;">最終ログイン日時：<br>{{ lastLogin }}</span>
      <span class="nav-item" style="font-size: 13px;">
        <b-icon icon="account"></b-icon>{{ getuserName(userName) }}
      </span>
      <span class="nav-item">
        <button
          class="button is-primary"
          type="button"
          slot="trigger"
          @click="help('PhilipsCarePortal操作マニュアル.pdf')"
        >
          <b-icon icon="help-circle"></b-icon>
          <span>ヘルプ</span>
        </button>
      </span>
      <span class="nav-item">
        <button class="button is-primary" type="button" slot="trigger" @click="logout">
          <b-icon icon="logout"></b-icon>
          <span>ログアウト</span>
        </button>
      </span>
    </div>
  </header>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import {isInternalUser} from "@/components/mock/base/const.js";
export default {
  name: "header",
  methods: {
    goToMenu: function() {
      if(this.roleId == this.role.role_admin || this.roleId == this.role.role_headOffice || this.roleId == this.role.role_headOffice_sales || this.roleId == this.role.role_headOffice_division 
        || this.roleId == this.role.role_headOffice_sw || this.roleId == this.role.role_salesOffice || this.roleId == this.role.role_psc || this.roleId == this.role.role_kawagoe){
        //内部ユーザー
        this.$router.push({ path: "/philips/home" });
      } else if(this.roleId == this.role.role_dealer) {
        //外部ユーザー（ディーラー）
        this.$router.push({ path: "/guest/home" });
      } else {
        //外部ユーザー(ディーラー以外)
        this.$router.push({ path: "/guest/home" });
      }
    },
    getuserName: function(value) {
      var length = 20;
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    logout: function(event) {
      this.$store.dispatch("logout", {}).then(() => {
        this.$router.push("/");
      });
    },
    help: function(filename) {
      // マニュアルのURLにリンク
      if(this.roleId == this.role.role_admin || this.roleId == this.role.role_headOffice || this.roleId == this.role.role_headOffice_sales || this.roleId == this.role.role_headOffice_division 
        || this.roleId == this.role.role_headOffice_sw || this.roleId == this.role.role_salesOffice || this.roleId == this.role.role_psc || this.roleId == this.role.role_kawagoe){
        //内部ユーザー
        this.downloadPdf(this.getUrlManual(), filename);
        } else if(this.roleId == this.role.role_dealer) {
        //外部ユーザー（ディーラー）
        this.downloadPdf(this.getUrlDealerManual(), filename);
        } else {
        //外部ユーザー(ディーラー以外)
        this.downloadPdf(this.getUrlManual(), filename);
        }
    },
    downloadPdf: function(pdf, filename) {
      const link = document.createElement("a");
      link.href = pdf;
      link.download = decodeURI(filename);
      link.click();
    },
    /**
     * Base64とMIMEコンテンツタイプからBlobオブジェクトを作成する。
     * 日本語対応。
     *
     * @param base64
     * @param mime_ctype MIMEコンテンツタイプ
     * @returns Blob
     */
    toBlob: function(base64, mime_ctype) {
      // 日本語の文字化けに対処するためBOMを作成する。
      var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      var bin = atob(base64.replace(/^.*,/, ""));
      var buffer = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      // Blobを作成
      try {
        var blob = new Blob([bom, buffer.buffer], {
          type: mime_ctype
        });
      } catch (e) {
        return false;
      }
      return blob;
    },
    redraw: function() {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userName = userInfo.lastName + " " + userInfo.firstName;
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let roleId = userInfo.roleId;
    const env = this.$store.state.env;
    return {
      userName: userInfo.lastName + " " + userInfo.firstName,
      roleId: roleId,
      lastLogin: sessionStorage.getItem("lastLoginDate"),
      role: role,
      env,
    };
  },
  mounted: async function(){
    var loadMasterList = [];
    loadMasterList.push(this.getOfficeMaster())
    loadMasterList.push(this.getStatusMaster())
    loadMasterList.push(this.getAuthMaster())
    loadMasterList.push(this.getKindMaster())
    loadMasterList.push(this.getChoiceMaster())

    var userInfo = this.getUserInfo();
    if (isInternalUser(this.roleId) || this.isEnableService(userInfo.useServiceId, service.cpap)) {
      loadMasterList.push(this.getPrescriptionHardware())
      loadMasterList.push(this.getCpapStatusMaster())
      loadMasterList.push(this.getCpapCommonMaster())
      loadMasterList.push(this.getCpapItemMaster())
    }

    var appVue = this.$root.$children[0]
    appVue.loadingStart()

    await Promise.all (loadMasterList)
    .then ((response) => {
      appVue.loadingEnd();
      console.log("マスター読み込み 正常終了");
    })
    .catch ((response) => {
      appVue.loadingEnd();
      console.log("マスター読み込み エラー終了\nerrorlog : " + response.message);
    });
  }
};
</script>

<style lang="scss">
.nav {
  z-index: 10;
}
.navbar {
  flex: 0;
}

.site-header {
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  padding: 12px 15px;
  z-index: 1000;
  position: fixed;
  text-align: left;
  vertical-align: middle;
}
.header-right {
  float: right;
}

.background {
  background: linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 50, 93) 20%,
    rgb(0, 119, 205) 100%
  );
  height: auto;
}

.background_dev {
  background: linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(230, 18, 194) 20%,
    rgb(240, 153, 225) 100%
  );
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/base/header.vue